<ng-container *ngIf="template && objectURL">
  <ng-container *ngTemplateOutlet="template; context: {$implicit : objectURL}"></ng-container>
</ng-container>